import request from '@/router/axios';


//查询项目详情
export const searchProjectDetail = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectDetail',
    method: 'get',
    params: data
  })
}

//获取全部项目列表
export const getAllProjects = (data) => {
  return request({
    url: '/svolt-ess-boss-service/connection/diagram/getAllProjects',
    method: 'get',
    params: data
  })
}
/* ---------------------------并网点------------------ */
//新增项目并网点
export const addProjectGrid = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGrid/addProjectGrid',
    method: 'post',
    data: data
  })
}

//查询项目并网点列表
export const searchProjectGridList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGrid/searchProjectGridList',
    method: 'get',
    params: data
  })
}
//更新项目并网点
export const updateProjectGrid = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGrid/updateProjectGrid',
    method: 'post',
    data: data
  })
}
//查询项目并网点详情
export const searchProjectGrid = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGrid/searchProjectGrid',
    method: 'get',
    params: data
  })
}
//根据并网点编号查询项目并网点的绑定设备
export const searchProjectGridEquipBindByGrid = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGridEquipBind/searchProjectGridEquipBindByGrid',
    method: 'get',
    params: data
  })
}

//查询项目下设备点结构树
export const getProjectEquipmentTree = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/getProjectEquipmentTree',
    method: 'get',
    params: data
  })
}

//根据并网点编号查询项目并网点的绑定设备
export const saveProjectGridEquipBind = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGridEquipBind/saveProjectGridEquipBind',
    method: 'post',
    data: data
  })
}

//查询项目下设备点结构树
export const searchProjectGridEquipDataPoints = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGridEquipDataPoint/searchProjectGridEquipDataPoints',
    method: 'get',
    params: data
  })
}

//查询设备的下数据组-树状
export const searchEquipDataGroupTree = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGridEquipDataPoint/searchEquipDataGroupTree',
    method: 'get',
    params: data
  })
}

//查询设备下数据点
export const searchEquipDataPoints = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGridEquipDataPoint/searchEquipDataPoints',
    method: 'get',
    params: data
  })
}

//生效项目并网点绑定设备
export const takeEffectProjectGridEquipBind = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGridEquipBind/takeEffectProjectGridEquipBind',
    method: 'post',
    data: data
  })
}

//保存并网点绑定设备的数据点映射
export const saveProjectGridEquipDataPointBind = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGridEquipDataPoint/saveProjectGridEquipDataPointBind',
    method: 'post',
    data: data
  })
}

export default {
  getProjectEquipmentTree,
  searchProjectDetail,
  getAllProjects,
  addProjectGrid,
  searchProjectGridList,
  updateProjectGrid,
  searchProjectGrid,
  searchProjectGridEquipBindByGrid,
  saveProjectGridEquipBind,
  searchProjectGridEquipDataPoints,
  searchEquipDataGroupTree,
  searchEquipDataPoints,
  takeEffectProjectGridEquipBind,
  saveProjectGridEquipDataPointBind
}



// WEBPACK FOOTER //
// ./src/api/parallel.js